import { ALLOCATE_VOUCHER, ALLOCATE_VOUCHER_SUCCESS, ALLOCATE_VOUCHER_ERROR, ALLOCATE_VOUCHER_EMPTY } from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const AllocateVoucher = (state = initialState, action) => {
  switch (action.type) {
    case ALLOCATE_VOUCHER:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case ALLOCATE_VOUCHER_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case ALLOCATE_VOUCHER_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case ALLOCATE_VOUCHER_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default AllocateVoucher;
